import { Dropdown, Menu } from "antd";
import "./account-menu.css";
import { UserAvatar, UserAvatarWithDetails } from "components/user-avatar";
import { getIsSSOLogin, getUser, logout } from "services/auth";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import LogoutIcon from "components/svg-icons/logout-icon";
import { useUserProfileInfo } from "hooks/users";

function AccountMenu() {
  const [currentUser]: [any, any] = useState(getUser());
  const [userInfo, setUserInfo] = useState<any>();
  const { data: userData } = useUserProfileInfo(currentUser.email);
  const history = useHistory();
  const isSSOLogin = getIsSSOLogin();

  useEffect(() => {
    if (!userData) return;
    if (userData.subscription_users.length > 0) {
      setUserInfo(userData.subscription_users[0]);
    }
  }, [userData]);

  const changePassword = () => {
    history.push("/change_password");
  };

  const menu = (
    <Menu className="p-0 space-y-1" data-testid="account-menu">
      <Menu.Item key="profile" className="px-2" data-testid="user-profile-item">
        <UserAvatarWithDetails
          showAvatar={false}
          fullName={
            userInfo
              ? `${userInfo?.user?.first_name} ${userInfo?.user?.last_name}`
              : undefined
          }
          email={currentUser.email}
          subscription={userInfo?.subscription?.name || ""}
        />
      </Menu.Item>

      {!isSSOLogin && (
        <>
          <Menu.Divider className="bg-[#3B3B3B80]" />
          <Menu.Item
            key="change-password"
            className="h-6"
            data-testid="change-password-item"
          >
            <div
              className="h-6 w-full ml-2 text-[10px] font-normal text-[#3B3B3BCC]"
              onClick={changePassword}
              data-testid="change-password-button"
              role="button"
              tabIndex={0}
              onKeyDown={() => {}}
            >
              Change Password
            </div>
          </Menu.Item>
        </>
      )}
      <Menu.Item key="sign-out" className="p-0" data-testid="logout-item">
        <div
          onClick={() => logout()}
          className="flex w-full h-6 items-center justify-between bg-ciq-gray-250 px-4 cursor-pointer"
          data-testid="logout-button"
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
        >
          <div className="flex h-full items-center font-semibold text-xs text-ciq-gray-800">
            Logout
          </div>
          <LogoutIcon />
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      arrow
      placement="bottomRight"
      overlay={menu}
      trigger={["click"]}
      data-testid="index-dropdown"
    >
      <div
        data-cy="account"
        data-testid="account-menu-trigger"
        className="accMenuContainer cursor-pointer"
      >
        <UserAvatar
          url=""
          isRect={false}
          fullName={
            userInfo
              ? `${userInfo?.user?.first_name} ${userInfo?.user?.last_name}`
              : ""
          }
        />
      </div>
    </Dropdown>
  );
}

export default AccountMenu;
